import {forwardRef} from 'react'
import {type TextProps} from 'react-native'
import {type SvgProps} from 'react-native-svg'
import {Image} from 'expo-image'

type Props = {
  allowVariants?: boolean
  fill?: string
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

export const Logo = forwardRef(function LogoImpl(props: Props, _ref) {
  const {style, width = 64} = props

  const size =
    typeof width === 'number' ? width : parseInt(String(width), 10) || 64

  return (
    <Image
      source={require('../../../assets/groovyverse-butterfly.png')}
      accessibilityLabel="GroovyVerse"
      accessibilityHint=""
      accessibilityIgnoresInvertColors
      style={[
        {
          width: size,
          height: size,
        },
        style,
      ]}
      contentFit="contain"
    />
  )
})
